document.addEventListener('DOMContentLoaded', () => {
  const menuDelay = {
    open: 250,
    close: 400,
  }
  let forceHide = false,
    keepOpen = false

  const $header = document.querySelector('nova-header')

  const $openMenu = $header.querySelector('.js-menu-toggle')
  const $closeMenu = $header.querySelector('.js-menu-close-button')

  const initialBgColor =
    getComputedStyle($header).getPropertyValue('--header-bg-color')

  const $drawerButtons = $header.querySelectorAll('.js-header-drawer-button')

  const $menuDrawerButtons = [...$drawerButtons].filter(
    (button) => button.dataset.type !== 'search',
  )

  const $headerDrawer = $header.querySelectorAll('.js-header-drawer')

  const $menuDrawer = [...$headerDrawer].filter(
    (drawer) => drawer.dataset.type !== 'search',
  )

  $openMenu.addEventListener('click', () => {
    $openMenu.classList.add('hidden')
    $closeMenu.classList.remove('hidden')
    $header.style.setProperty('--header-bg-color', '#fff')

    document.dispatchEvent(new CustomEvent('nova:mobile-menu:open'))
  })

  $closeMenu.addEventListener('click', () => {
    handleMenuIconClose()
    document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'))
  })

  document.addEventListener('nova:menu:closed-in-modal', () =>
    handleMenuIconClose(),
  )

  const handleMenuIconClose = () => {
    $closeMenu.classList.add('hidden')
    $openMenu.classList.remove('hidden')
    $header.style.setProperty('--header-bg-color', initialBgColor)
  }

  const handleInlineMenuDrawer = (event) => {
    forceHide = false
    const $button = event.target.closest('.js-header-drawer-button')
    if (!$button) return

    const targetReference = $button.dataset.target
    const $target = $header.querySelector(`#${targetReference}`)
    if (!$target) return

    for (const $drawer of $headerDrawer) {
      if ($drawer === $target) {
        if (!$drawer.hasAttribute('is-open')) {
          setTimeout(() => {
            if (!forceHide) $drawer.show()
          }, menuDelay.open)
        } else if (event.type === 'click') {
          forceHide = true
          setTimeout(() => {
            $drawer.hide()
          }, menuDelay.close)
        }
      } else {
        $drawer.hide()
      }
    }
  }

  const handleHideInlineMenuDrawer = (event) => {
    const $button = event.target.closest('.js-header-drawer-button')
    if (!$button) return

    const targetReference = $button.dataset.target
    const $target = $header.querySelector(`#${targetReference}`)
    if (!$target) return

    forceHide = true

    setTimeout(() => {
      if (!keepOpen) $target.hide()
    }, menuDelay.close)
  }

  const closeDrawer = (event) => {
    let $drawer = null

    keepOpen = false
    if (
      event.target.classList.contains('drawer__overlay') ||
      event.target.classList.contains('drawer__panel')
    ) {
      $drawer = event.target.getRootNode().host
      $drawer?.hide()
      return
    }
    $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    $drawer.hide()
  }

  const closeAllDrawer = (event) => {
    keepOpen = false
    for (const $drawer of $menuDrawer) {
      $drawer.hide()
    }
  }

  const handleDrawerAttributesAndEvents = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    const targetReference = $drawer.id
    const $button = $header.querySelector(`[data-target="${targetReference}"]`)
    const $buttonOpenIcon = $button.querySelector('.js-header-drawer-icon-open')
    if (!$button) return
    if (event.type === 'sl-hide') {
      $drawer.removeAttribute('is-open')
      $button.removeAttribute('is-open')
      if ($buttonOpenIcon) {
        $buttonOpenIcon.dataset.tabIndex = 0
      }
      dispatchDrawerHideEvent($drawer)
    } else if (event.type === 'sl-show') {
      $drawer.setAttribute('is-open', '')
      $button.setAttribute('is-open', '')
      if ($buttonOpenIcon) {
        $buttonOpenIcon.dataset.tabIndex = -1
      }
      dispatchDrawerShowEvent($drawer)
    }
  }

  const dispatchDrawerShowEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:open', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  const dispatchDrawerHideEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:close', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  for (const $drawer of $headerDrawer) {
    $drawer.addEventListener('sl-hide', handleDrawerAttributesAndEvents)
    $drawer.addEventListener('sl-show', handleDrawerAttributesAndEvents)
  }

  for (const $button of $drawerButtons) {
    $button.addEventListener('click', handleInlineMenuDrawer)
  }

  for (const $button of $menuDrawerButtons) {
    $button.addEventListener('mouseenter', handleInlineMenuDrawer)
    $button.addEventListener('mouseleave', handleHideInlineMenuDrawer)
  }

  for (const $drawer of $menuDrawer) {
    $drawer?.shadowRoot?.firstElementChild?.children[0]?.addEventListener(
      'mouseenter',
      closeDrawer,
    )
  }

  for (const $drawer of $menuDrawer) {
    $drawer?.shadowRoot?.firstElementChild?.children[1]?.addEventListener(
      'mouseenter',
      () => {
        keepOpen = true
      },
    )
    $drawer?.shadowRoot?.firstElementChild?.children[1]?.addEventListener(
      'mouseleave',
      closeDrawer,
    )
  }

  const addHeaderOffsetVariable = () => {
    document.documentElement.style.setProperty(
      '--header-height',
      `${document.querySelector('.header-container').offsetHeight}px`,
    )
    document.documentElement.style.setProperty(
      '--header-primary-height',
      `${document.querySelector('.header').offsetHeight}px`,
    )
    if (document.querySelector('.announcement-bar')) {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${document.querySelector('.announcement-bar').offsetHeight}px`,
      )
    }
  }

  addHeaderOffsetVariable()
  window.addEventListener('resize', addHeaderOffsetVariable)
})
